export const FOOTER_HEIGHT = "58px";
